<template>
  <empty-baseball-cell :title="title">
    <img slot="icon" src="../../../assets/images/kbo/icon-empty.png">
    <a slot="button" href="#" @click.prevent="action">
      <span>{{btnText}}</span>
    </a>
  </empty-baseball-cell>
</template>
<script>
  import _ from 'lodash'
  import EmptyBaseballCell from '@/components/model/cell/EmptyBaseballCell'
  import KboDate from '@/common/model/KboDate'
  import { getTeamLatelyGameDate } from '@/common/utils/request'
  export default {
    name: 'EmptyScheduleToday',
    components: {
      EmptyBaseballCell
    },
    data () {
      return {
        title: '오늘은 경기가 없어요.',
        btnText: '다음 경기 일정 보기'
      }
    },
    methods: {
      action () {
        getTeamLatelyGameDate({ date: new KboDate().getYearMonthDate() })
          .then(({ data }) => {
            const cantFindNextMatch = _.get(data, 'is_null', false) === true
            if (cantFindNextMatch) {
              alert('다음 경기 데이터가 없습니다.')
            } else {
              const query = this.$route.query
              const toDay = new KboDate()
              try {
                this.$router.push({
                  name: 'baseball_schedule',
                  query: Object.assign({}, query, { date: _.get(data, 'lately_date', toDay.getYearMonthDate()) })
                })
              } catch (e) {}
            }
          })
      }
    }
  }
</script>
